import { Card, CardContent, CardHeader, Switch, ToggleButton, Typography } from "@mui/material";
import { toDate } from "helpers/dateHelper";
import { useGetChannelDetails } from "hooks/useGetChannelDetails";
import withRouter from "hoc/withRouter";
import WhatsappConnect, { CHANNEL_STATUS, CONNECTION_STATUS } from "../Whatsapp/WhatsappConnect";
import { useTranslation } from "react-i18next";
import ChannelConnectionsAdminService from "services/admin/channelConnections";
import { toast } from "react-toastify";
import { TelegramConnect } from "./components/TelegramConnect";
import { InstagramConnect } from "./components/InstagramConnect";
import { TestSandboxConnect } from "./components/TestSandboxConnect";

const AgentChannelDetails = ({
  router: {
    params: { id: agentID, channelConnectionID },
  },
}: any) => {
  const { data: channelDetails, refetch } = useGetChannelDetails(channelConnectionID);
  const { t } = useTranslation();

  if (!channelDetails) return <div>Загрузка...</div>;

  const buildChannelConnection = () => {
    switch (channelDetails.source) {
      case "WHATSAPP":
        return <WhatsappConnect channelConnection={channelDetails} refetch={refetch} />;
      case "TELEGRAM":
        return <TelegramConnect channelConnection={channelDetails} refetch={refetch} />;
      case "INSTAGRAM":
        return <InstagramConnect channelConnection={channelDetails} refetch={refetch} />;
      case "TEST_SANDBOX":
        return <TestSandboxConnect channelConnection={channelDetails} refetch={refetch} />;
      default:
        return <div>Неизвестный тип канала</div>;
    }
  };

  const handleChangeStatus = async () => {
    try {
      await ChannelConnectionsAdminService.put(channelDetails.id, {
        status:
          channelDetails.status === CHANNEL_STATUS.ACTIVE
            ? CHANNEL_STATUS.INACTIVE
            : CHANNEL_STATUS.ACTIVE,
      });
      toast.success("Статус канала изменен успешно!");
      refetch();
    } catch (error) {
      toast.error("Ошибка при изменении статуса канала!");
      console.error(error);
    }
  };

  return (
    <div>
      <h3 className="mb-8">Детали подключения канала</h3>
      <Card>
        <CardHeader title={"Информация о канале"} />
        <CardContent>
          <Typography variant="body1">ID: {channelDetails.id}</Typography>
          <Typography variant="body1">Тип канала: {channelDetails.source}</Typography>
          <div>
            Статус:{" "}
            <Switch
              checked={channelDetails.status === CHANNEL_STATUS.ACTIVE}
              onChange={handleChangeStatus}
              color="primary"
            />
          </div>
          <Typography variant="body1">Создано: {toDate(channelDetails.createdAt)}</Typography>
          <Typography variant="body1">Обновлено: {toDate(channelDetails.updatedAt)}</Typography>
        </CardContent>
      </Card>
      <Card className="mt-4">
        <CardHeader title="Информация о подключении" />
        <CardContent>
          <div className="mb-2">
            <div>
              Статус подключения: &nbsp;
              <span
                className="font-bold"
                style={{
                  color:
                    channelDetails.connectionStatus === CONNECTION_STATUS.CONNECTED
                      ? "green"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.WAITING_QR
                      ? "orange"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.PENDING
                      ? "orange"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.DISCONNECTED
                      ? "gray"
                      : channelDetails.connectionStatus === CONNECTION_STATUS.ERROR
                      ? "red"
                      : "gray",
                }}
              >
                {t(`CONNECTION_STATUS.${channelDetails.connectionStatus}`)}
              </span>
            </div>
          </div>
          <div>{buildChannelConnection()}</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default withRouter(AgentChannelDetails);
